<script setup lang="ts">
import {computed} from "vue";
import type {IStoreBannerDefault} from "@/api/aj-trends.model.ts";

const props = defineProps<{ banner: IStoreBannerDefault, active?: boolean }>()

const activeClasses = computed(() => {
  return props.active ? ['g-bg-primary', 'g-color-white'] : ['g-bg-gray-light-v4']
})
</script>

<template>
  <a
      :href="`#${banner.name}`"
      :class="activeClasses"
      class="u-tags-v1 g-color-main g-bg-black--hover g-color-white--hover g-color-black--active g-py-4 g-px-10"
  >
    {{ banner.name }}
  </a>
</template>
